// services/API/userManagement.js
import commonAPI from "../commonAPI"; // <-- generic axios wrapper

const staffUserAPI = {
  // Get all users
  getUsers: () => commonAPI.get("/auth/staffusers"),

  // Add user
  addUser: (payload) => commonAPI.post("/auth/staffregister", payload),

  // Update user
  updateUser: (id, payload) =>
    commonAPI.put(`/auth/staffusers/${id}`, payload),

  // Delete user
  deleteUser: (id) => commonAPI.delete(`/auth/staffusers/${id}`),
};

export default staffUserAPI;
